import io from "socket.io-client";

const id = "mobile_user";
const userType = "MOBILE";
const socket = io("https://silo-socket-server.herokuapp.com/", {
  // const socket = io("https://silo-socket-server-staging.herokuapp.com/", {
  query: { userType, id },
});

const initialState = {
  io: socket,
};

export default (state = initialState, action) => {
  return state;
};
